import sizes from '../../theme/foundations/sizes'
import {pxToRem} from '../../utills/pxToRem'

export const addressStyles = {
    p: {
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: 'normal',
        color: 'black',
        letterSpacing: pxToRem(1)
    },
    h3: {
        color: 'black',
        textTransform: 'uppercase'
    }
}
